import PropTypes from 'prop-types'

import placeholderFactory from './factory'

export default placeholderFactory('AcpHeader', {
  children: PropTypes.node.isRequired,
})
